<svg #svg class="stage-svg" [attr.viewBox]="'0 0 ' + VIEW_W + ' ' + VIEW_H"
     preserveAspectRatio="xMidYMid meet">

  <defs>
    <radialGradient id="fh-panel" cx="50%" cy="30%" r="90%">
      <stop offset="0%" stop-color="#3a2a6b" />
      <stop offset="55%" stop-color="#241a4d" />
      <stop offset="100%" stop-color="#160f33" />
    </radialGradient>
  </defs>

  <rect x="0" y="0" [attr.width]="VIEW_W" [attr.height]="VIEW_H" rx="0"
        fill="url(#fh-panel)" stroke="rgba(255,255,255,0.14)" stroke-width="2" />

  <!-- Starfield -->
  <g fill="#ffffff">
    <circle cx="160" cy="70" r="2" opacity="0.5" /><circle cx="430" cy="55" r="1.6" opacity="0.35" />
    <circle cx="700" cy="80" r="2.2" opacity="0.55" /><circle cx="880" cy="60" r="1.5" opacity="0.4" />
    <circle cx="90" cy="150" r="1.6" opacity="0.4" /><circle cx="940" cy="150" r="2" opacity="0.5" />
  </g>

  <!-- Number line -->
  <g class="numline" stroke="#eef3ff" stroke-width="4" stroke-linecap="round">
    <line [attr.x1]="X0 - 40" [attr.y1]="LINE_Y" [attr.x2]="X_END + 40" [attr.y2]="LINE_Y" />
    <polyline [attr.points]="(X0 - 40) + ',' + (LINE_Y - 12) + ' ' + (X0 - 56) + ',' + LINE_Y + ' ' + (X0 - 40) + ',' + (LINE_Y + 12)" fill="none" />
    <polyline [attr.points]="(X_END + 40) + ',' + (LINE_Y - 12) + ' ' + (X_END + 56) + ',' + LINE_Y + ' ' + (X_END + 40) + ',' + (LINE_Y + 12)" fill="none" />
  </g>
  <g class="ticks">
    <g *ngFor="let t of ticks">
      <line [attr.x1]="valueToX(t)" [attr.y1]="LINE_Y - 14" [attr.x2]="valueToX(t)" [attr.y2]="LINE_Y + 14"
            stroke="#eef3ff" stroke-width="4" />
      <text [attr.x]="valueToX(t)" [attr.y]="LINE_Y + 50" text-anchor="middle" class="tick-label">{{ t }}</text>
    </g>
  </g>

  <!-- Hop arcs -->
  <path *ngFor="let a of arcs" class="arc" [attr.d]="a.d" />
  <!-- landing dots at each hop end -->
  <circle *ngFor="let a of arcs" class="hop-dot"
          [attr.cx]="valueToX((a.index + 1) * hop)" [attr.cy]="LINE_Y" r="6" />

  <!-- Success: brace + the product shown clearly on the line -->
  <g *ngIf="solvedState" class="reveal">
    <path class="brace" [attr.d]="braceD" />
    <text class="brace-label" [attr.x]="braceMidX" [attr.y]="braceTopY" text-anchor="middle">
      {{ round?.whole }}&#215;
    </text>
    <!-- landing marker on the line + product pill just below it -->
    <circle class="land-dot" [attr.cx]="frogX" [attr.cy]="LINE_Y" r="9" />
    <line class="land-drop" [attr.x1]="frogX" [attr.y1]="LINE_Y" [attr.x2]="productX" [attr.y2]="LINE_Y + 44" />
    <g [attr.transform]="'translate(' + productX + ',' + (LINE_Y + 82) + ')'">
      <rect class="product-pill" [attr.x]="-pillW / 2" y="-34" [attr.width]="pillW" height="66" rx="16" />
      <text class="product-text" x="0" y="2" text-anchor="middle" dominant-baseline="central">{{ productLabel }}</text>
    </g>
  </g>

  <!-- Sparkles -->
  <g *ngIf="solvedState">
    <circle *ngFor="let s of sparkles" class="sparkle" [attr.cx]="s.x" [attr.cy]="s.y" [attr.r]="s.r"
            [style.animation-delay.ms]="s.delay" fill="#fff4b0" />
  </g>

  <!-- Frog on the pad -->
  <g class="frog" [class.hopped]="justHopped" [class.win]="solvedState"
     [attr.transform]="'translate(' + frogX + ',' + LINE_Y + ')'">
    <rect x="-26" y="4" width="52" height="9" rx="4" fill="#c7cede" />
    <text class="count-label" x="0" y="-58" text-anchor="middle">{{ count }}&#215;</text>
    <text class="frog-emoji" x="0" y="-16" text-anchor="middle" dominant-baseline="central">🐸</text>
  </g>

  <!-- Wrong wash -->
  <rect *ngIf="wrongFlash" class="wrong-flash" x="0" y="0" [attr.width]="VIEW_W" [attr.height]="VIEW_H" rx="0" />
</svg>
